// File: src/components/finance/FinancePartners.jsx
import React from "react";
import "../../styles/FinancePartners.css";

const FinancePartners = () => {
  const partners = [
    { name: "bandhan Bank", logo: "idfc-first" },
    { name: "IDFC First Bank", logo: "idfc-first" },
    { name: "HDFC Bank", logo: "hdfc" },
    { name: "ICICI Bank", logo: "icici" },
    { name: "Kotak Mahindra Prime", logo: "kotak" },
    { name: "Axis Bank", logo: "axis" },
    { name: "Bajaj Finserv", logo: "bajaj" },
    { name: "Piramal Finance", logo: "piramal" },
    { name: "TVS Credit", logo: "tvs" },
    { name: "Mahindra Finance", logo: "mahindra" },
    { name: "AU Small Finance Bank", logo: "au" },
    { name: "IndusInd Bank", logo: "indusind" }
  ];

  return (
    <section className="finance-partners">
      <div className="partners-container">
        <h2>Our Finance Partners</h2>
        <div className="partners-grid">
          {partners.map((partner, index) => (
            <div key={index} className="partner-card">
              <div className="partner-logo-wrapper">
                {/* Placeholder for actual logos - you'll need to add real logo images */}
                <div className="partner-logo-placeholder">
                  {partner.name}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FinancePartners;